import type { MouseEventHandler } from 'react';

import { SecondaryButton } from '@atoms/buttons/SecondaryButton';

import { CANCEL_TEXT } from './constants';

type Props = {
  onAction: MouseEventHandler<HTMLButtonElement>;
};

export const CancelButton = ({ onAction }: Props) => {
  const handleButtonClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.stopPropagation();
    onAction?.(event);
  };

  return (
    <SecondaryButton
      size="large"
      className="w-full"
      onClick={handleButtonClick}
    >
      {CANCEL_TEXT}
    </SecondaryButton>
  );
};
